import $ from 'jquery';
import BaseView from '../../../core/baseView';
import * as lightbox from '../../../../home24/helpers/lightbox';
import { getBaseUrl } from '../../../../home24/core/config';

export default BaseView.extend({
  events: {
    'change .myaccount-select-form select': 'onActionChange',
    'focus .myaccount-select-form select': 'onActionFocus',
    'click .js-b2b-cancellation-button': 'onB2bCancelButtonClick',
    'click .js-ffh-cancellation-button': 'onFfhCancelButtonClick'
  },

  /**
   * Submit form and go to reclamation FTTC2 process
   * @param {Event} e
   */
  onActionChange: function(e) {
    var $currentTarget = $(e.currentTarget);
    var nodeId = $currentTarget.val();

    switch (nodeId) {
      case 'b2bCancel':
        this.openCancellationLightBox(
          $('.js-b2b-order-cancellation'),
          'b2b-order-cancellation'
        );
        break;

      case 'ffhCancel':
        this.openCancellationLightBox(
          $('.js-ffh-order-cancellation'),
          'ffh-order-cancellation'
        );
        break;

      case 'retryPayment':
        var orderNumber = $currentTarget
          .closest('form')
          .find('[name="order_number"]')
          .val();
        this.goToRetryPaymentPage(orderNumber);
        break;

      default:
        $(e.currentTarget)
          .closest('form')
          .submit();
        break;
    }
  },

  /**
   * By default it is not possible to track a change on a select box
   * if the same value has been selected. The solution is to select first element of the
   * select box on select box focus. This makes sure that
   * every selection (beside the first option) will trigger onchange event on select box.
   *
   * @param {Event} e javascript event object
   */
  onActionFocus: function(e) {
    $(e.currentTarget)
      .children(':first-child')
      .prop('selected', 'selected');
  },

  onB2bCancelButtonClick: function(e) {
    e.preventDefault();

    this.openCancellationLightBox(
      $('.js-b2b-order-cancellation'),
      'b2b-order-cancellation'
    );
  },

  onFfhCancelButtonClick: function(e) {
    e.preventDefault();

    this.openCancellationLightBox(
      $('.js-ffh-order-cancellation'),
      'ffh-order-cancellation'
    );
  },

  openCancellationLightBox: function($el, className) {
    lightbox
      .setConfig({
        $dialog: $el,
        className: className
      })
      .open();
  },

  goToRetryPaymentPage: function(orderNumber) {
    window.location.href = `${getBaseUrl()}/checkout/notification/retry/id/${orderNumber}`;
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/orders/OrderListView.js
 **/